import { ExplainModule } from '../core/user/user.model';
import { TerritoryForAccountInfo } from './territory/territory-utils';

/**
 * Interface describing Account info.
 * 02/09/2022: only carrying department territories allowed for the current user
 * 13/04/2026: carrying modules (modules accessible for the account)
 */
export interface DbAccountInfo {
  territories: Array<TerritoryForAccountInfo>;
  modules: Array<ExplainModule>;
}

/**
 * Class describing Account info.
 * 02/09/2022: only carrying territories (departments accessible for the account)
 * 13/04/2026: carrying modules (modules accessible for the account)
 */
export class AccountInfo {
  private _territories: Array<TerritoryForAccountInfo>;
  private _modules: Array<ExplainModule>;

  constructor(dbAccountInfo: DbAccountInfo) {
    this._territories = dbAccountInfo.territories;
    this._modules = dbAccountInfo.modules;
  }

  get territories(): Array<TerritoryForAccountInfo> {
    return this._territories;
  }

  set territories(value: Array<TerritoryForAccountInfo>) {
    this._territories = value;
  }

  get modules(): Array<ExplainModule> {
    return this._modules;
  }

  set modules(value: Array<ExplainModule>) {
    this._modules = value;
  }
}
